import React, { FC, memo, RefObject, useMemo } from 'react'

import styles from './RTEContent.module.scss'

type RTEContentProps = Omit<React.DetailedHTMLProps<React.BaseHTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'dangerouslySetInnerHTML' | 'ref'> & {
  html: string
  ref?: RefObject<HTMLDivElement>
}

export const RTEContent: FC<RTEContentProps> = memo(({ html, ...props }) => {
  const processedRTEContent = useMemo(() => (html || '').trim().replace(/\n/g, '<br/>'), [html])

  return (
    <div className={styles.rteContent} dangerouslySetInnerHTML={{ __html: processedRTEContent }} {...props} />
  )
})
